<template>
  <Form ref="formValidate" :label-width="120">
    <FormItem label="操作：">
      <Select
        :transfer="true"
        v-model="formItem.selectOption"
        :label-in-value="true"
        @on-change="changeInstruction"
      >
        <Option v-for="key in Object.keys(opType)" :value="key" :key="key">
          {{ opType[key].cn }}
        </Option>
      </Select>
    </FormItem>
    <FormItem label="设备检索条件：">
      <Select v-model="formItem.selectCondition" @on-change="changeInput">
        <Option value="idCard">身份证号</Option>
        <Option value="meterId">设备编号</Option>
        <Option value="meterType">设备类型</Option>
        <Option value="address">地址</Option>
      </Select>
    </FormItem>
    <FormItem label="输入或选择条件：">
      <i-input
        v-model="formItem.inputIdCard"
        @on-change="changeInput"
        placeholder="请输入身份证号"
        v-if="formItem.selectCondition == 'idCard'"
      ></i-input>
      <i-input
        v-model="formItem.inputMeterId"
        @on-change.stop="changeInput"
        placeholder="请输入设备编号"
        v-if="formItem.selectCondition == 'meterId'"
      ></i-input>
      <Cascader
        :data="addressData"
        change-on-select
        filterable
        transfer
        @on-change="choiceAll"
        v-if="formItem.selectCondition == 'address'"
      ></Cascader>
    </FormItem>
  </Form>
</template>

<script>
export default {
  props: {
    callback: {
      type: Function,
    },
  },
  data() {
    return {
      formItem: {},
      opType: global.profileTest,
    };
  },
  methods: {
    changeInstruction(e) {
      this.callback(this.formItem);
      console.log(this.formItem);
    },
    changeInput() {
      this.callback(this.formItem);
    },
    choiceAll(data) {
      if (data.length > 0) {
        this.formItem.addressDataSelect = data[data.length - 1].toString();
      } else {
        this.formItem.addressDataSelect = null;
      }
      this.callback(this.formItem);
    },
    onChangeSelectOption() {
      this.callback(this.formItem);
    },
  },
};
</script>

<style scoped></style>
